<template>
  <LayoutLogin>
    <template v-slot:content>
      <LayoutLoginCard>
        <div class="d-flex justify-center my-6">
          <Logo type="big" />
        </div>

        <p class="my-4 text-body-1 text-center">
          {{ $t('auth.access.validating_credentials') }}
        </p>

        <LoaderSpinner v-if="isLoading" />
      </LayoutLoginCard>
    </template>
  </LayoutLogin>
</template>

<script>
import qs from 'qs'

import mixin from '@/mixins/mixin.vue'
import authMixin from '@/mixins/authMixin.vue'
import api from '@/api'
import { isOfficeEnvironment, sendDataToOffice } from '@/lib/office'

import LayoutLogin from '@/components/Core/Layout/LayoutLogin'
import LayoutLoginCard from './components/LayoutLoginCard.vue'
import Logo from '@/components/Core/Logo/Logo.vue'
import LoaderSpinner from '@/components/utils/LoaderSpinner.vue'

export default {
  name: 'GoogleRedirectView',

  mixins: [mixin, authMixin],

  data() {
    return {
      isLoading: true,
    }
  },

  components: {
    LayoutLogin,
    LayoutLoginCard,
    Logo,
    LoaderSpinner,
  },

  mounted() {
    this.signIn()
  },

  methods: {
    async signIn() {
      try {
        const { data: reverSession } = await api.account.googleAuth({
          code: this.$route.query.code,
          redirectUri: encodeURI(`${document.location.origin}/access/google`),
        })

        const callback = sessionStorage.getItem('callback')
        const redirect = sessionStorage.getItem('redirect')

        this.$track('session.Start', this.$store, {
          process: 'GoogleLogin',
          status: 'success',
        })

        if (isOfficeEnvironment()) {
          return sendDataToOffice({
            account: reverSession.account,
            accessToken: reverSession.accessToken,
          })
        }

        if (callback)
          return this.navigateToExternalRoute(
            `${callback}?accessToken=${reverSession.accessToken}`
          )

        this.setLoginData(reverSession)
        this.replaceRoute(redirect ?? '/home')
      } catch (error) {
        this.handleError(
          `${this.$t(
            'error.auth.login_failed_please_try_again_later'
          )} - ${error?.response?.data?.message ?? error}`
        )
      }
    },

    getTokenFromUrl() {
      return this.$route.hash !== ''
        ? this.getTokenFromQueryString(this.$route.hash.substring(1))
        : null
    },

    getTokenFromQueryString(queryString) {
      const parsedQuery = qs.parse(queryString)
      return parsedQuery.id_token ? parsedQuery.id_token : null
    },

    handleError(error) {
      this.$track('session.Start', this.$store, {
        process: 'GoogleLogin',
        status: 'fail',
        error,
      })
      this.showError(error)
      this.replaceRoute({ name: 'access' })
    },
  },
}
</script>

<style lang="scss" scoped>
.google-auth-wait {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
